import { Grid, Typography, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
const LocationDetails = ({
  classes,
  settings,
  setSettings,
  isValid,
  setIsValid,
}) => {
  const [timeZone, setTimeZone] = useState(
    settings?.generalSettings?.location?.latlng
  );
  const [gmtTimeZone, setGMTTimeZone] = useState("");
  const handleChange = (e) => {
    let { name, value } = e.target;
    let obj = settings.generalSettings;
    obj.location[name] = value;
    setSettings({ ...settings, generalSettings: obj });
    if (
      name === "city" ||
      name === "state" ||
      name === "postal_code" ||
      name === "country"
    ) {
      console.log("inside the check", name);
      validationHandler(name, value);
    }
  };
  function computeGMTOffset(timeZoneId) {
    // Create two date objects, one with a specific timezone and one with the UTC timezone
    const localDate = new Date().toLocaleString("en-US", {
      timeZone: timeZoneId,
    });
    const utcDate = new Date().toLocaleString("en-US", { timeZone: "UTC" });
    // Parse the dates back to Date objects
    const date1 = new Date(localDate);
    const date2 = new Date(utcDate);
    // Compute the difference in hours
    let offset = date1 - date2;
    offset /= 1000 * 60 * 60; // Convert offset from milliseconds to hours

    // Convert the offset to the desired format
    const prefix = offset < 0 ? "GMT" : "GMT+";
    return prefix + offset;
  }

  let TimeZone; // This should return something like "GMT-4" or "GMT-5" depending on Daylight Saving Time
  useEffect(() => {
    const timeZoneId = timeZone?.timeZoneId;
    TimeZone = !timeZoneId || computeGMTOffset(timeZoneId);
    setGMTTimeZone(TimeZone);
  }, [timeZone]);
  const [isFormValid, setIsFormValid] = useState({
    landmark: {
      valid: true,
      error: "",
    },
    street: {
      valid: true,
      error: "",
    },
    postal_code: {
      valid: true,
      error: "",
    },
    city: {
      valid: true,
      error: "",
    },
    state: {
      valid: true,
      error: "",
    },
    country: {
      valid: true,
      error: "",
    },
  });
  const validationHandler = (name, value) => {
    switch (name) {
      case "landmark":
        if (value.trim().length < 2) {
          setIsFormValid({
            ...isFormValid,
            landmark: { valid: false, error: "Invalid Input" },
          });
          setIsValid({ valid: false, error: "Invalid Restaurant Location!" });
        } else {
          setIsFormValid({
            ...isFormValid,
            landmark: { valid: true, error: "" },
          });
          setIsValid(
            checkOverallValid(name) === true
              ? { valid: true, error: "" }
              : { valid: false, error: "Invalid Restaurant Location!" }
          );
        }
        break;
      case "street":
        if (value.trim().length < 2) {
          setIsFormValid({
            ...isFormValid,
            street: { valid: false, error: "Invalid Input" },
          });
          setIsValid({ valid: false, error: "Invalid Restaurant Location!" });
        } else {
          setIsFormValid({
            ...isFormValid,
            street: { valid: true, error: "" },
          });
          setIsValid(
            checkOverallValid(name) === true
              ? { valid: true, error: "" }
              : { valid: false, error: "Invalid Restaurant Location!" }
          );
        }
        break;
      case "postal_code":
        if (value.trim().length < 1) {
          setIsFormValid({
            ...isFormValid,
            postal_code: { valid: false, error: "Invalid Input" },
          });
          setIsValid({ valid: false, error: "Invalid Restaurant Location!" });
        } else {
          setIsFormValid({
            ...isFormValid,
            postal_code: { valid: true, error: "" },
          });
          setIsValid(
            checkOverallValid(name) === true
              ? { valid: true, error: "" }
              : { valid: false, error: "Invalid Restaurant Location!" }
          );
        }
        break;
      case "state":
        if (value.trim().length < 2) {
          setIsFormValid({
            ...isFormValid,
            state: { valid: false, error: "Invalid Input" },
          });
          setIsValid({ valid: false, error: "Invalid Restaurant Location!" });
        } else {
          setIsFormValid({
            ...isFormValid,
            state: { valid: true, error: "" },
          });
          setIsValid(
            checkOverallValid(name) === true
              ? { valid: true, error: "" }
              : { valid: false, error: "Invalid Restaurant Location!" }
          );
        }
        break;
      case "city":
        if (value.trim().length < 2) {
          setIsFormValid({
            ...isFormValid,
            city: { valid: false, error: "Invalid Input" },
          });
          setIsValid({ valid: false, error: "Invalid Restaurant Location!" });
        } else {
          setIsFormValid({
            ...isFormValid,
            city: { valid: true, error: "" },
          });
          setIsValid(
            checkOverallValid(name) === true
              ? { valid: true, error: "" }
              : { valid: false, error: "Invalid Restaurant Location!" }
          );
        }
        break;
      case "country":
        if (value.trim().length < 2) {
          setIsFormValid({
            ...isFormValid,
            country: { valid: false, error: "Invalid Input" },
          });
          setIsValid({ valid: false, error: "Invalid Restaurant Location!" });
        } else {
          setIsFormValid({
            ...isFormValid,
            country: { valid: true, error: "" },
          });
          setIsValid(
            checkOverallValid(name) === true
              ? { valid: true, error: "" }
              : { valid: false, error: "Invalid Restaurant Location!" }
          );
        }
        break;

      default:
        return;
    }
  };

  const checkInitialState = (current) => {
    if (settings?.generalSettings?.location) {
      for (let i in settings?.generalSettings?.location) {
        if (
          i === "state" ||
          i === "city" ||
          i === "country" ||
          i === "postal_code"
        ) {
          if (settings?.generalSettings?.location[i].length < 1) {
            console.log(
              "key",
              settings?.generalSettings?.location[i].length,
              i,
              current
            );
            return false;
          }
        }
      }
    }
    return true;
  };
  const checkOverallValid = (name) => {
    console.log("check the intial state", checkInitialState(name));
    switch (name) {
      case "landmark":
        if (
          checkInitialState(name).valueOf(true) &&
          isFormValid.street.valid &&
          isFormValid.city.valid &&
          isFormValid.state.valid &&
          isFormValid.postal_code.valid &&
          isFormValid.country.valid
        ) {
          return true;
        } else {
          return false;
        }
        break;
      case "street":
        if (
          checkInitialState(name).valueOf(true) &&
          isFormValid.landmark.valid &&
          isFormValid.city.valid &&
          isFormValid.state.valid &&
          isFormValid.postal_code.valid &&
          isFormValid.country.valid
        ) {
          return true;
        } else {
          return false;
        }
        break;
      case "post_code":
        if (
          checkInitialState(name).valueOf(true) &&
          isFormValid.street.valid &&
          isFormValid.city.valid &&
          isFormValid.state.valid &&
          isFormValid.landmark.valid &&
          isFormValid.country.valid
        ) {
          return true;
        } else {
          return false;
        }
        break;
      case "city":
        if (
          checkInitialState(name).valueOf(true) &&
          isFormValid.street.valid &&
          isFormValid.landmark.valid &&
          isFormValid.state.valid &&
          isFormValid.postal_code.valid &&
          isFormValid.country.valid
        ) {
          return true;
        } else {
          return false;
        }
        break;
      case "state":
        if (
          checkInitialState(name).valueOf(true) &&
          isFormValid.street.valid &&
          isFormValid.city.valid &&
          isFormValid.landmark.valid &&
          isFormValid.postal_code.valid &&
          isFormValid.country.valid
        ) {
          return true;
        } else {
          return false;
        }
        break;
      case "country":
        if (
          checkInitialState(name).valueOf(true) &&
          isFormValid.street.valid &&
          isFormValid.city.valid &&
          isFormValid.state.valid &&
          isFormValid.postal_code.valid &&
          isFormValid.landmark.valid
        ) {
          return true;
        } else {
          return false;
        }
        break;

      default:
        return;
    }
  };

  return (
    <Grid container direction="row" spacing={2} className={classes.mt30}>
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Landmark
        </Typography>
      </Grid>
      <Grid item xs={12} sm={10} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          fullWidth
          variant="outlined"
          size="small"
          name="landmark"
          value={settings?.generalSettings?.location?.landmark || ""}
          onChange={handleChange}
          helperText={!isFormValid.landmark.valid && isFormValid.landmark.error}
          error={!isFormValid.landmark.valid}
          inputProps={{
            "aria-label": "ladmark_input",
          }}
        />
      </Grid>
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Street
        </Typography>
      </Grid>
      <Grid item xs={12} sm={10} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          fullWidth
          variant="outlined"
          size="small"
          name="street"
          value={settings?.generalSettings?.location?.street || ""}
          onChange={handleChange}
          helperText={!isFormValid.street.valid && isFormValid.street.error}
          error={!isFormValid.street.valid}
          inputProps={{
            "aria-label": "street_input",
          }}
        />
      </Grid>
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Zip Code
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          fullWidth
          variant="outlined"
          size="small"
          name="postal_code"
          value={settings?.generalSettings?.location?.postal_code || ""}
          onChange={handleChange}
          helperText={
            !isFormValid.postal_code.valid && isFormValid.postal_code.error
          }
          error={!isFormValid.postal_code.valid}
          inputProps={{
            "aria-label": "postal_code_input",
          }}
        />
      </Grid>
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          City
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          fullWidth
          variant="outlined"
          size="small"
          name="city"
          value={settings?.generalSettings?.location?.city || ""}
          onChange={handleChange}
          helperText={!isFormValid.city.valid && isFormValid.city.error}
          error={!isFormValid.city.valid}
          inputProps={{
            "aria-label": "city_input",
          }}
        />
      </Grid>

      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          State
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          fullWidth
          variant="outlined"
          size="small"
          name="state"
          value={settings?.generalSettings?.location?.state || ""}
          onChange={handleChange}
          helperText={!isFormValid.state.valid && isFormValid.state.error}
          error={!isFormValid.state.valid}
          inputProps={{
            "aria-label": "state_input",
          }}
        />
      </Grid>
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Country
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          fullWidth
          variant="outlined"
          size="small"
          name="country"
          value={settings?.generalSettings?.location?.country || ""}
          onChange={handleChange}
          helperText={!isFormValid.country.valid && isFormValid.country.error}
          error={!isFormValid.country.valid}
          inputProps={{
            "aria-label": "country_input",
          }}
        />
      </Grid>
      {timeZone ? (
        <>
          <Grid item xs={12} sm={2} className={classes.mt30}>
            <Typography variant="body1" className={classes.typographyStyles}>
              Time Zone
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} className={classes.mt30}>
            <Typography style={{ width: "350px" }}>
              {`${timeZone.timeZoneId} (${gmtTimeZone})`}
            </Typography>
          </Grid>{" "}
        </>
      ) : (
        ""
      )}
    </Grid>
  );
};

export default LocationDetails;
